module.exports = __webpack_public_path__ + "static/media/edge.15317f39.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/edge.png
// module id = 6
// module chunks = 0